import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row py-4 gx-" }
const _hoisted_2 = { class: "col d-flex flex-row" }
const _hoisted_3 = {
  key: 0,
  "aria-label": "breadcrumb",
  class: "ms-4 mt-auto text-center"
}
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  class: "circle clickable ms-auto",
  id: "dropdownMenuButton1",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}

import { useUserStore } from "@/stores/user-store";
import { getAuth } from "firebase/auth";
import { useRouter } from "vue-router";
import { computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();

const router = useRouter();

async function signOut() {
  await getAuth()
    .signOut()
    .then(() => {
      router.go(0);
    });
}

const crumbs = computed<{ path: string; to: string; text: string }[]>(() => {
  let pathArray: string[] = router.currentRoute.value.path.split("/");
  pathArray.shift();
  return pathArray.reduce<{ path: string; to: string; text: string }[]>(
    (breadcrumbArray, path, index) => {
      breadcrumbArray.push({
        path: path,
        to: "#" + pathArray.slice(0, index).join("/") + "/" + path,
        text:
          (router.currentRoute.value.matched[index]?.meta?.breadCrumb as
            | string
            | null) ?? path,
      });
      return breadcrumbArray;
    },
    []
  );
});

const showRoute = computed<boolean>(() => {
  return router.currentRoute.value?.meta?.showRoute != false ?? true;
});

watch(
  () => router.currentRoute.value,
  (route) => {
    console.log("Route matched", route);
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(showRoute) && _unref(crumbs).length > 1)
        ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
            _createElementVNode("ol", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(crumbs), (crumb) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "breadcrumb-item",
                  key: crumb
                }, [
                  _createElementVNode("a", {
                    href: crumb.to
                  }, _toDisplayString(crumb.text), 9, _hoisted_5)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(userStore).user?.displayName?.charAt(0) ?? ""), 1),
      _createElementVNode("ul", {
        class: "dropdown-menu",
        "aria-labelledby": "dropdownMenuButton1"
      }, [
        _createElementVNode("li", null, [
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: signOut
          }, "Sign out")
        ])
      ])
    ])
  ]))
}
}

})